import React, { useState } from 'react';
import PropTypes from 'prop-types';

import downIcon from '../../assets/images/down-chevron.svg';
import upIcon from '../../assets/images/up-chevron.svg';
import catHombres from '../../assets/images/new/CAT HOMBRES.svg';
import catMujeres from '../../assets/images/new/CAT MUJERES.svg';
import catMixto from '../../assets/images/new/CAT MIXTO.svg';
import proCyclistIcon from '../../assets/images/new/CICLISTA PRO.svg';

import { Row, Col } from 'react-flexbox-grid';

const TableRankingTeamItem = ({
  cre,
  sprint,
  userInfo,
  calendar,
  raceDay,
  firstRaking,
  darkMode,
  teamFavorites,
  saveTeamFavorite,
  deleteTeamFavorite,
  overlapBadge,
  favoritesEnabled,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const addButtonText = () => {
    if (!favoritesEnabled) return null;
    let buttonText = '+';
    let saveFunction = saveTeamFavorite;
    let favoriteId = calendar ? userInfo.team.id : userInfo.id;
    if (teamFavorites) {
      teamFavorites.forEach((teamFavorite) => {
        if (
          teamFavorite.teamId === (calendar ? userInfo.team.id : userInfo.id)
        ) {
          buttonText = '-';
          favoriteId = teamFavorite.teamId;
          saveFunction = deleteTeamFavorite;
        }
      });
    }
    return (
      <div
        onClick={() => {
          saveFunction(favoriteId);
        }}
        className='add-button'
      >
        {buttonText}
      </div>
    );
  };

  const openAcordion = () => {
    setIsOpen(!isOpen);
  };

  const getCategoryIcon = (gender) => {
    if (gender === 'MEN') return catHombres;
    if (gender === 'WOMEN') return catMujeres;
    return catMixto;
  };

  const getCategoryLabel = (gender) => {
    if (gender === 'MEN') return 'HOMBRES';
    if (gender === 'WOMEN') return 'MUJERES';
    return 'MIXTO';
  };

  const normalizeGenderCategory = (value) => {
    const gender = String(value || '').toUpperCase();
    if (gender === 'MEN' || gender === 'MALE' || gender === 'M') return 'MEN';
    if (
      gender === 'WOMEN' ||
      gender === 'FEMALE' ||
      gender === 'F' ||
      gender === 'MUJERES'
    ) {
      return 'WOMEN';
    }
    return 'MIXED';
  };

  const isProAthlete = (athlete) => {
    const category = String(athlete?.category || '').toUpperCase();
    return category.includes('PRO');
  };

  const elapsedName = () => {
    if (cre) {
      return 'day_elapsed_time';
    }
    if (sprint) {
      return 'sprintElapsedTime';
    }
    return 'elapsed_time';
  };

  const showTime = (timeDate, status) => {
    const elapsedSeconds = Number(timeDate || 0);
    const validTime = status === 0 && elapsedSeconds > 0;
    const waiting = status === 1 || (status === 0 && elapsedSeconds <= 0);
    const dnf = status === 2;
    const dq = status === 3;
    const formatCalendarTime12h = (dateValue) => {
      const parsedDate = new Date(dateValue);
      if (Number.isNaN(parsedDate.getTime())) return '--:--:--';
      const hours24 = parsedDate.getUTCHours();
      const hours12 = hours24 % 12 || 12;
      const mm = String(parsedDate.getUTCMinutes()).padStart(2, '0');
      const ss = String(parsedDate.getUTCSeconds()).padStart(2, '0');
      return `${hours12}:${mm}:${ss}`;
    };

    if (calendar) {
      if (!timeDate) return <div>--:--:--</div>;
      return <div>{formatCalendarTime12h(timeDate)}</div>;
    } else {
      return (
        <div>
          {dnf && 'DNF'}
          {dq && 'DQ'}
          {waiting && 'Esperando tiempo'}
          {validTime &&
            new Date(elapsedSeconds * 1000).toISOString().substr(11, 8)}
          {validTime &&
            firstRaking.id !== userInfo.id && (
              <div className='table-ranking-item_user-info-team'>
                {firstRaking.id !== userInfo.id && <span>{'+ '}</span>}
                {firstRaking.id === userInfo.id
                  ? `${new Date(elapsedSeconds * 1000).toISOString().substr(11, 8)}`
                  : `${new Date(
                      Math.abs(
                        elapsedSeconds - Number(firstRaking[elapsedName()] || 0)
                      ) * 1000
                    )
                      .toISOString()
                      .substr(11, 8)}`}
              </div>
            )}
        </div>
      );
    }
  };

  const showTimeUser = (timeDate, status, note) => {
    const elapsedSeconds = Number(timeDate || 0);
    const validTime = status === 0 && elapsedSeconds > 0;
    const waiting = status === 1 || (status === 0 && elapsedSeconds <= 0);
    const dnf = status === 2;
    const dq = status === 3;
    const formatCalendarTime12h = (dateValue) => {
      const parsedDate = new Date(dateValue);
      if (Number.isNaN(parsedDate.getTime())) return '--:--:--';
      const hours24 = parsedDate.getUTCHours();
      const hours12 = hours24 % 12 || 12;
      const mm = String(parsedDate.getUTCMinutes()).padStart(2, '0');
      const ss = String(parsedDate.getUTCSeconds()).padStart(2, '0');
      return `${hours12}:${mm}:${ss}`;
    };
    if (calendar) {
      if (!timeDate) return <div>--:--:--</div>;
      return <div>{formatCalendarTime12h(timeDate)}</div>;
    } else if (cre || !calendar) {
      return (
        <div>
          {dnf && 'DNF'}
          {dq && 'DQ'}
          {waiting && 'Esperando tiempo'}
          {validTime && new Date(elapsedSeconds * 1000).toISOString().substr(11, 8)}
          {note !== '' && <div className='note-text'>{note}</div>}
        </div>
      );
    } else {
      return '';
    }
  };

  const teamGender = normalizeGenderCategory(
    calendar ? userInfo?.team?.gender : userInfo?.gender
  );

  return (
    <Col xs={12} className={`table-ranking-item${darkMode ? ' darkMode' : ''}`}>
      <Row className='table-ranking-item_column-container'>
        <Col xs={12}>
          <Row className='table-ranking-item_column-container_main'>
            <Col xs={3} className='table-ranking-item_column'>
              {addButtonText()}
              <div className='position-text'>{userInfo.ranking}</div>
            </Col>
            <Col
              xs={5}
              className={`table-ranking-item_column team-main-column${
                overlapBadge ? ' team-overlap' : ''
              }`}
              onClick={openAcordion}
            >
              <div className='table-ranking-item_team-content'>
                <div
                  className={`team-type-badge team-type-badge-${teamGender.toLowerCase()}`}
                  title={getCategoryLabel(teamGender)}
                >
                  <img
                    src={getCategoryIcon(teamGender)}
                    alt={getCategoryLabel(teamGender)}
                    className='team-type-badge_icon'
                  />
                </div>
                <div className='table-ranking-item_user-info-container team-name-container'>
                  <div className='table-ranking-item_user-info-name'>
                    <span className='name-text'>
                      {calendar ? userInfo.team.name : userInfo.name}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={4}
              className='table-ranking-item_column'
              onClick={openAcordion}
            >
              <div className='table-ranking-item_category'>
                {showTime(
                  calendar ? userInfo.startTime : userInfo[elapsedName()],
                  calendar ? 0 : userInfo.race_status
                )}
                <img
                  src={isOpen ? upIcon : downIcon}
                  alt='down'
                  className='down-icon'
                />
              </div>
            </Col>
          </Row>
        </Col>
        {isOpen && (
          <Col xs={12}>
            {(calendar
              ? userInfo.team['participants']
              : userInfo['participants']
            ).map((athlete) => {
              return (
                <Row
                  key={athlete.id}
                  className='table-ranking-item_column-container_secundary individual'
                >
                  <Col xs={3} className='table-ranking-item_column'></Col>
                  <Col xs={5} className='table-ranking-item_column team-main-column'>
                    <div className='table-ranking-item_user-img-container'>
                      <div
                        className={`fallback-avatar fallback-avatar-${normalizeGenderCategory(
                          athlete.gender
                        ).toLowerCase()}`}
                        title={getCategoryLabel(
                          normalizeGenderCategory(athlete.gender)
                        )}
                      >
                        <img
                          src={getCategoryIcon(
                            normalizeGenderCategory(athlete.gender)
                          )}
                          alt={getCategoryLabel(
                            normalizeGenderCategory(athlete.gender)
                          )}
                          className='fallback-avatar-icon'
                        />
                      </div>
                      {athlete.photo_url && (
                        <img
                          src={athlete.photo_url}
                          alt='user'
                          className='table-ranking-item_user-img'
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      )}
                    </div>
                    <div className='table-ranking-item_user-info-container'>
                      <div className='table-ranking-item_user-info-name'>
                        <span className='name-text'>
                          {`${athlete.name} ${
                            athlete[calendar ? 'lastName' : 'last_name']
                          }`}
                        </span>
                        {isProAthlete(athlete) && (
                          <img
                            src={proCyclistIcon}
                            alt='pro'
                            className='pro-cyclist-icon'
                          />
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col xs={4} className='table-ranking-item_column'>
                    <div className='table-ranking-item_category'>
                      {showTimeUser(
                        calendar
                          ? userInfo.startTime
                          : cre
                            ? athlete.lap_elapsed_time
                            : athlete.elapsed_time,
                        calendar ? 0 : 0,
                        calendar ? '' : ''
                      )}
                    </div>
                  </Col>
                </Row>
              );
            })}
          </Col>
        )}
      </Row>
    </Col>
  );
};

TableRankingTeamItem.propTypes = {
  saveTeamFavorite: PropTypes.func.isRequired,
  deleteTeamFavorite: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired,
  calendar: PropTypes.bool,
  raceDay: PropTypes.object.isRequired,
  firstRaking: PropTypes.object.isRequired,
  teamFavorites: PropTypes.array.isRequired,
  darkMode: PropTypes.bool,
  cre: PropTypes.bool,
  sprint: PropTypes.bool,
  overlapBadge: PropTypes.bool,
  favoritesEnabled: PropTypes.bool,
};

TableRankingTeamItem.defaultProps = {
  calendar: false,
  darkMode: false,
  cre: false,
  sprint: false,
  overlapBadge: false,
  favoritesEnabled: false,
};

export default TableRankingTeamItem;
